/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

/* ================= CONFIG ================= */
// ✅ FIXED (fallback added)
const API = process.env.REACT_APP_API_URL || "/api";

const Alerts = () => {
  const [alerts, setAlerts] = useState([]);
  const token = localStorage.getItem("token");

  const fetchAlerts = async () => {
    try {
      const res = await fetch(`${API}/alerts`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = await res.json();

      // ✅ SAFE PARSE
      const safeData = Array.isArray(data)
        ? data
        : data.rows || data.data || [];

      setAlerts(safeData);

    } catch (err) {
      console.error("Alerts fetch error:", err);
      setAlerts([]);
    }
  };

  useEffect(() => {
    fetchAlerts();
  // Load alerts once when the page opens.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <h1 className="text-xl font-semibold text-slate-800 mb-6">
        Alerts
      </h1>

      <div className="bg-white rounded-xl border overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs">
            <tr>
              <th className="px-6 py-3 text-left">Device</th>
              <th className="px-6 py-3 text-left">Type</th>
              <th className="px-6 py-3 text-left">Severity</th>
              <th className="px-6 py-3 text-left">Time</th>
            </tr>
          </thead>

          <tbody>
            {alerts.length === 0 ? (
              <tr>
                <td colSpan="4" className="p-6 text-center text-gray-400">
                  No alerts
                </td>
              </tr>
            ) : (
              alerts.map((alert) => (
                <tr key={alert.id} className="border-t">

                  <td className="px-6 py-4">
                    {alert.device_uid || "-"}
                  </td>

                  <td className="px-6 py-4">
                    {alert.type || "-"}
                  </td>

                  <td className="px-6 py-4">
                    <span
                      className={`px-2 py-1 text-xs rounded ${
                        alert.severity === "Critical"
                          ? "bg-red-100 text-red-600"
                          : "bg-yellow-100 text-yellow-600"
                      }`}
                    >
                      {alert.severity || "-"}
                    </span>
                  </td>

                  <td className="px-6 py-4 text-gray-500">
                    {alert.created_at
                      ? new Date(alert.created_at).toLocaleString()
                      : "-"}
                  </td>

                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Alerts;
